import { Chip, Paper, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { isArray, isString } from "lodash";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

export function TagsContainer({ contact }) {

    const [tags, setTags] = useState([]);
    const [selecteds, setSelecteds] = useState([]);
    const isMounted = useRef(true);

    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        if (isMounted.current) {
            loadTags().then(() => {
                if (Array.isArray(contact?.tags)) {
                    setSelecteds(contact.tags);
                } else {
                    setSelecteds([]);
                }
            });
        }
    }, [contact]);

    const createTag = async (data) => {
        try {
            const { data: responseData } = await api.post(`/tags`, data);
            return responseData;
        } catch (err) {
            toastError(err);
        }
    };

    const loadTags = async () => {
        try {
            const { data } = await api.get(`/tags/list`, {
                params: { kanban: 0 }
            });
            if (isMounted.current) {
                setTags(Array.isArray(data) ? data : []);
            }
        } catch (err) {
            toastError(err);
        }
    };

    const syncTags = async (data) => {
        try {
            const { data: responseData } = await api.post(`/tags/sync`, data);
            return responseData;
        } catch (err) {
            toastError(err);
        }
    };

    const onChange = async (value, reason) => {
        let optionsChanged = [];
        if (reason === 'create-option') {
            if (isArray(value)) {
                for (let item of value) {
                    if (isString(item)) {
                        if (item.trim().length < 3) {
                            toastError(i18n.t("tags.validation.short"));
                            return;
                        }
                        const newTag = await createTag({ name: item.trim(), kanban: 0, tagsystem: 0, color: getRandomHexColor() });
                        if (newTag) {
                            optionsChanged.push(newTag);
                        }
                    } else {
                        optionsChanged.push(item);
                    }
                }
            }
            await loadTags();
        } else {
            optionsChanged = value || [];
        }
        setSelecteds(optionsChanged);
        if (contact?.id) {
            await syncTags({ contactId: contact.id, tags: optionsChanged });
        }
    };

    function getRandomHexColor() {
        const red = Math.floor(Math.random() * 256);
        const green = Math.floor(Math.random() * 256);
        const blue = Math.floor(Math.random() * 256);
        return `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`;
    }

    return (
        <Paper elevation={0} style={{ padding: '8px 0', backgroundColor: 'inherit', border: 'none', boxShadow: 'none' }}>
            <Autocomplete
                multiple
                size="small"
                options={tags}
                value={selecteds}
                freeSolo
                onChange={(e, v, r) => onChange(v, r)}
                getOptionLabel={(option) => (typeof option === 'string' ? option : option?.name || "")}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip
                            key={index}
                            variant="outlined"
                            style={{
                                backgroundColor: (typeof option === 'object' && option?.color) ? option.color : '#00b4d8',
                                color: "#FFF",
                                marginRight: 4,
                                marginBottom: 4,
                                padding: 2,
                                fontWeight: 'bold',
                                paddingLeft: 6,
                                paddingRight: 6,
                                borderRadius: 4,
                                fontSize: "0.8em",
                                whiteSpace: "nowrap"
                            }}
                            label={typeof option === 'string' ? option : option?.name || ""}
                            {...getTagProps({ index })}
                            size="small"
                        />
                    ))
                }
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" label={i18n.t("tags.title")} placeholder={i18n.t("tags.title")} />
                )}
            />
        </Paper>
    );
}
